<template lang="pug">
    span.mainEventsOfDay
        .container
            app-closer(@click.native="$emit('close')")
            .content
                h5 {{day.NAME}}
                events-grid
                    router-link(tag="a" :to="'/'+event.DAY_CODE+'/'+event.CODE" v-for="(event, ind) in (day.EVENTS || []).slice(0, 3)" :key="ind")
                        div
                        event-card(:event="event")
                router-link(tag="h6" :to="'/'+day.CODE") {{$t('home.watchAllDay')}}
                .app_btn.subscribe.white_fill(@click="$store.commit('openPopup', 'Subscribe'), $store.commit('setPopupContent', {type: 'day', code: day.CODE, name: day.NAME})") {{$t('other.subscribeDay')}}
            .arrow.prev(@click="$emit('prev')")
            .arrow.next(@click="$emit('next')")
</template>

<script>
    import EventsGrid from "./EventsGrid";
    import EventCard from "./EventCard";

    export default {
        name: "MainEventsOfDay",
        data() {
            return {
                list: null
            }
        },
        props: {
            day: {
                default: () => ({})
            }
        },
        watch: {
            day(item) {
                item.EVENTS.forEach((event,i) => {
                    if (event.EVENT_MAIN === "yes") {
                        item.EVENTS.splice(i,1)
                        item.EVENTS.unshift(event)
                    }
                })
                return  item
            }
        },
        components: {
            EventCard, EventsGrid
        }
    }
</script>

<style scoped lang="scss">

    .mainEventsOfDay {
        position: relative;
        z-index: 1;
        display: block;
        min-width: 100vw;
        width: 100vw;
        padding-right: 17px;
        margin-left: calc((100vw - 100% - 17px) / -2);
        transform: translateY(-1.3rem);
        background: #fff;
        color: #000;
        overflow: hidden;
        transition: .4s linear;
        @include razr1620 {
            margin-left: -20px;
        }

        &:before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 100vw;
            z-index: -1;
            background: #fff;
        }

        &:not(.open) {
            opacity: 0;
            height: 0 !important;
        }

        &.fade .content {
            opacity: 0;
        }
    }

    .container {
        position: relative;

        .closer {
            position: absolute;
            z-index: 1;
            top: 1rem;
            left: 100%;
        }

        .arrow {
            position: absolute;
            top: 49%;
            transform: translateY(-50%);
            width: 3rem;
            height: 5rem;
            background: url(../../assets/img/arrow_black.png) no-repeat center center / contain;
            cursor: pointer;

            &.prev {
                right: 101.5%;
                transform: translateY(-50%) scale(-1, 1);
            }

            &.next {
                left: 101.5%;
                transform: translateY(-50%);
            }
        }

        @include razr1680 {
            max-width: 91vw;
            .closer {
                left: 98%;
                width: 4rem;
                height: 4rem;
            }
            .arrow {
                &.prev {
                    right: 100%;
                }

                &.next {
                    left: 100%;
                }
            }
        }
    }

    .content {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2rem 0 2.7rem;
        transition: .3s linear;

        h5, h6 {
            position: relative;

            &:after {
                content: '';
                display: block;
                position: absolute;
                top: 93%;
                left: 0;
                right: 0;
                height: 2px;
                background: #000;
            }
        }

        h5 {
            margin-bottom: 1.5rem;
            font-size: 2.5rem;
        }

        h6 {
            margin-top: 1.25rem;
            font-size: to_rem(30px);
            cursor: pointer;
        }

        .subscribe {
            position: absolute;
            bottom: 2.7rem;
            right: 0.5rem;
        }
    }

    @include mobile_or_P {
        .mainEventsOfDay {
            width: 100vw;
            margin-left: -1.4rem;
            padding-right: 0;
        }
        .container {
            max-width: 100vw;

            .closer {
                left: auto;
                right: 1.25rem;
                width: 2.5rem;
                top: 1.25rem;
                height: 2.5rem;
            }

            .arrow {
                top: 2.9rem;
                height: 2.9rem;

                &.prev {
                    right: auto;
                    left: 21.5%;
                }

                &.next {
                    left: auto;
                    right: 21.5%;
                }
            }
        }
        .content {
            padding: 1.9rem 0 2.7rem;

            h5 {
                margin-bottom: 2rem;
                font-size: 1.9rem;
            }

            h6 {
                align-self: flex-start;
                margin-top: 1.6rem;
                margin-left: 0.45rem;
                font-size: 1.42rem;
            }

            .subscribe {
                right: 0.8rem;
                padding: 0.4rem 0.6rem 0.2rem;
                font-size: 0.92rem;
            }
        }
    }
</style>
